module.exports = "//static.hsappstatic.net/LoginUI/static-1.14821/img/SUI_desktop.svg"